import { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { useAppDispatch } from "@/app/hooks";
import { RootState } from "@/app/rootReducer";
import { fetchEventNotificationsAction } from "../slices/eventNotificationsSlice";

interface Pagination {
  pageIndex: number;
  pageSize: number;
}

export function useEventNotifications() {
  const dispatch = useAppDispatch();

  const { notifications, totalCount, loading, error } = useSelector(
    (state: RootState) => state.eventNotifications,
  );

  const [pagination, setPagination] = useState<Pagination>({
    pageIndex: 0,
    pageSize: 10,
  });

  useEffect(() => {
    dispatch(fetchEventNotificationsAction());
  }, [dispatch]);

  const handlePaginationChange = useCallback((newPagination: Pagination) => {
    setPagination(newPagination);
  }, []);

  return {
    notifications,
    totalCount,
    loading,
    error,
    pagination,
    handlePaginationChange,
  };
}
